export enum ValidatorModalType {
  REMOVE_VALIDATOR = 'removeValidator',
  IDENTITIES_DUMP = 'identitiesDump',
}

export enum KmsDriver {
  AWS = 'aws',
  AZURE = 'azure',
}

export const VALIDATOR_NAME_PREFIX = 'validator-';

export const KMS_DRIVER_OPTIONS = [
  { value: KmsDriver.AWS, label: 'AWS' },
  { value: KmsDriver.AZURE, label: 'Azure' },
] as const;
